<template>
  <v-card-title>
    <v-container class="pa-12">
      <v-card class="pl-16 pr-16 pt-8 pb-16">
        <v-card-title>
          <v-row>
            <v-col cols="6" md="6" justify="center">
              <h3>Edit Leave Quota</h3>
            </v-col>
            <v-col cols="6" md="6"> </v-col>
          </v-row>
        </v-card-title>
        <br />
        <v-row class="heightsize70formadvance">
          <v-col cols="12" md="5">
            <v-text-field
              v-model="company_name"
              outlined
              dense
              disabled
              label="Company Name"
              background-color="#F5F5F5"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="7"></v-col>
        </v-row>
        <v-row class="heightsize70formadvance">
          <v-col cols="12" md="5">
            <v-text-field
              v-model="employee_id"
              outlined
              dense
              disabled
              label="Employee ID"
              background-color="#F5F5F5"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="1"></v-col>
          <v-col cols="12" md="5">
            <v-text-field
              v-model="employee_name"
              outlined
              dense
              disabled
              label="Employee Name"
              background-color="#F5F5F5"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="1"></v-col>
        </v-row>
        <v-row class="heightsize70formadvance">
          <v-col cols="12" md="5">
            <v-text-field
              v-model="department_name"
              outlined
              dense
              disabled
              label="Department"
              background-color="#F5F5F5"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="1"></v-col>
          <v-col cols="12" md="5">
            <v-text-field
              v-model="position_name"
              outlined
              dense
              disabled
              background-color="#F5F5F5"
              label="Position"
            ></v-text-field
          ></v-col>
          <v-col cols="12" md="1"></v-col>
        </v-row>
        <v-row class="heightsize70formadvance">
          <v-col cols="12" md="5" style="font-size: 16px">
            Start Date: {{ showstartdate }}
          </v-col>
          <v-col cols="12" md="6" offset="1" style="font-size: 16px"
            >Employment Duration: {{ showduraions }}
          </v-col>
        </v-row>
        <v-row class="heightsize70formadvance">
          <v-col cols="12" md="2">Period From</v-col>
          <v-col cols="12" md="3">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="computeddatefromFormatted"
                  label="Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="period_datefrom"
                @input="menu = false"
                @change="ckeckperiod"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="1"></v-col>

          <v-col cols="12" md="1">To</v-col>
          <v-col cols="12" md="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="computeddateToFormatted"
                  label="Date"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="period_dateto"
                @input="menu2 = false"
                @change="ckeckperiod"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <template>
          <template>
            <row>
              <v-col cols="12" md="1"></v-col>
              <v-col cols="12" md="11">
                <v-data-table
                  :headers="headers"
                  :items="desserts"
                  sort-by="calories"
                  class="elevation-1"
                  show-select
                  v-model="selected"
                  item-key="id"
                  @input="enterSelect($event)"
                  hide-default-footer
                >
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize"> Reset </v-btn>
                  </template>

                  <template v-slot:item.actionsD="item">
                    <v-text-field
                      :disabled="item.item.disabled"
                      v-model="item.item.quotaD"
                      v-on:change="changeRoute(item)"
                      type="number"
                      min="0"
                    ></v-text-field>
                  </template>
                  <template v-slot:item.actionsH="item">
                    <v-text-field
                      :disabled="item.item.disabled"
                      v-model="item.item.quotaH"
                      v-on:change="changeRoute(item)"
                      type="number"
                      min="0"
                      max="7"
                    ></v-text-field>
                  </template>
                </v-data-table>
              </v-col>
            </row>
          </template>
        </template>
        <br />
        <v-row class="heightsize70formadvance">
          <v-col cols="12" md="12">
            <v-text-field
              v-model="remark"
              outlined
              dense
              label="Remark"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="7"></v-col>
        </v-row>

        <br />

        <br />
        <div>
          <v-row>
            <v-col align="center" cols="12" md="12">
              <v-btn class="mr-5 buttonblue" @click="saveQuota()"> Save </v-btn>
              <v-btn to="/leave-quota" depressed> Cancel </v-btn>
            </v-col>
          </v-row>

          <!-- <v-row>
            <v-col align="end" cols="12" md="12">
              <v-btn depressed class="buttonred">
                Delete form
              </v-btn>
            </v-col>
          </v-row> -->
        </div>
      </v-card>

      <v-dialog v-model="dialogSendMail" max-width="500px">
        <v-card>
          <v-card-title class="text-h6">Information Saved</v-card-title>
          <v-card-subtitle>
            บันทึกข้อมูลและส่งอีเมล์ถึงผู้อนุมัติสำเร็จ
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="blue darken-1" text @click="closeDeleteForm"
              >Cancel</v-btn
            > -->
            <v-btn color="blue darken-1" text @click="closeDialogSendmail()"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSaveDraft" max-width="30%">
        <v-card>
          <v-card-title primary-title class="justify-center">
            {{ this.messageSaveDraft }}</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="blue darken-1" text @click="closeSaveDraft"
                          >Cancel</v-btn
                        > -->
            <v-btn color="blue darken-1" text @click="closeSaveDraft">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeleteimage" max-width="500px">
        <v-card>
          <v-card-title class="text-h5"
            >Are you sure you want to delete this item?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDeleteimage"
              >Cancel</v-btn
            >
            <v-btn color="blue darken-1" text @click="removeimage">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <SuccessDialog
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
      />

      <SuccessDialogPush
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
        :link="link"
      />
    </v-container>
  </v-card-title>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { imageUrl } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "./computing/tolocalestringnumber";
import unity from "@/unity/unity";

export default {
  name: "NewAdvance",
  data() {
    return {
      menu: false,
      menu2: false,
      add_leaveQuota: {},
      update_per: {},
      remarklist: {},
      dialogDeleteimage: false,
      desserts: [],
      headers: [
        {
          text: "ID",
          value: "leave_id",
          class: "bg-colorth",
          width: "8%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Leave Type",
          align: "center",
          value: "leave_type",
          class: "bg-colorth texttablehcenter",
          width: "20%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Quota(Days)",
          value: "actionsD",
          class: "bg-colorth texttablehcenter ",
          width: "20%",
          divider: true,
          align: "center",
          sortable: false,
        },
        {
          text: "Quota(Hour)",
          value: "actionsH",
          class: "bg-colorth texttablehcenter ",
          width: "20%",
          divider: true,
          align: "center",
          sortable: false,
        },
        {
          text: "Used(Days)",
          align: "center",
          value: "use_leave_c",
          class: "bg-colorth texttablehcenter",
          width: "34%",
          align: "start",
          divider: true,
          sortable: false,
        },
      ],
      remark: "",
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      datefrom: "",
      dateto: "",
      checklistNull: 0,
      main_id: 0,
      main_periodfrom: "",
      main_periodto: "",
      periovdFrom: "",
      periovdTO: "",
      chechlog: 0,
      period_datefrom: "",
      period_dateto: "",
      statusAdd: "",
      status_update_dateperiod: 0, // 0 อัพเดตวัน 1 ไม่อัพเดตวัน
      showduraions: "",
      showstartdate: "",
    };
  },
  components: {
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    computeddatefromFormatted() {
      return unity.formatDate(this.period_datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.period_dateto);
    },
  },

  async mounted() {
    this.loadData();
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    this.$hideLoader();
  },
  methods: {
    calculateWorkDuration(startDate) {
      const start = new Date(startDate);
      const now = new Date();

      if (start > now) {
        return "Invalid start date";
      }

      let years = now.getFullYear() - start.getFullYear();
      let months = now.getMonth() - start.getMonth();

      // ตัดเศษวัน
      if (now.getDate() < start.getDate()) {
        months--;
      }

      // ปรับเดือนติดลบ
      if (months < 0) {
        years--;
        months += 12;
      }

      if (years > 0 && months > 0) {
        return `${years} years ${months} months`;
      }

      if (years > 0) {
        return `${years} years`;
      }

      if (months > 0) {
        return `${months} months`;
      }

      return `0 months`;
    },
    async loadData() {
      this.main_id = this.$route.params.id;
      this.main_periodfrom = this.$route.params.period_datefrom;
      this.main_periodto = this.$route.params.period_dateto;
      const resultC = await api.getAccountByid(this.main_id);
      //console.log(resultC.data)

      this.company_id = resultC.data[0].company_id;
      this.company_name = resultC.data[0].company_name;
      this.employee_id = resultC.data[0].id;
      this.employee_name = resultC.data[0].name;
      this.department_name = resultC.data[0].department_name;
      this.position_name = resultC.data[0].position_name;
      this.period_datefrom = this.main_periodfrom;
      this.period_dateto = this.main_periodto;
      this.showstartdate = resultC.data[0].show_start_date;
      if (resultC.data.length > 0 && resultC.data[0].start_date) {
        this.showduraions = this.calculateWorkDuration(
          resultC.data[0].start_date
        );
      }
      const res_dataedit = await api.getDataEditLeaveQuota(
        this.main_id,
        this.period_datefrom,
        this.period_dateto,
        Number(localStorage.getItem(server.COMPANYID))
      );
      this.desserts = res_dataedit.data;
      //console.log(res_dataedit.data);
      this.desserts.forEach((item) => {
        item.quotaD = Math.floor(item.quota);
        item.quotaH = Math.floor((item.quota % 1).toFixed(4) * 8);
        item.quotaDC = item.quotaD;
        item.quotaHC = item.quotaH;
        let useCD = 0;
        let useCH = 0;
        let useCM = 0;
        useCD = Math.floor(item.use_leave);
        useCH = Math.floor((item.use_leave - useCD).toFixed(4) * 8);
        useCM =
          ((item.use_leave - useCD).toFixed(4) * 8 - useCH).toFixed(1) * 60;
        item.use_leave_c =
          useCD + " Days " + useCH + " Hour " + useCM + " Minute";
        item.disabled = true;
        if (item.quota_id) {
          this.remark = item.remark;
        }
        //item.actionsH
      });
      console.log(this.desserts);
    },

    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async ckeckperiod() {
      if (this.period_datefrom > this.period_dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Period From > Period To",
          "text-h5 red--text text-center"
        );
        return;
      }
      //check period
      if (
        this.period_datefrom == this.main_periodfrom &&
        this.period_dateto == this.main_periodto
      ) {
        this.status_update_dateperiod = 0;
      } else {
        const checkperiod = await api.getcheckeditperiodquota(
          this.main_id,
          this.period_datefrom,
          this.period_dateto,
          this.main_periodfrom,
          this.main_periodto
        );
        //console.log(checkperiod.data)
        this.status_update_dateperiod = 1;
        if (checkperiod.data[0].status > 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "ช่วงเวลาซ้ำ กรุณาตรวจสอบข้อมูล",
            "text-h5 red--text text-center"
          );
          this.period_datefrom = this.main_periodfrom;
          this.period_dateto = this.main_periodto;
          return;
        }
      }
    },
    async saveQuota() {
      if (this.checklistNull == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Leave Quota ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.period_datefrom == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Enter Period From",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.period_dateto == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Enter Period To",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.period_datefrom > this.period_dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Period From > Period To",
          "text-h5 red--text text-center"
        );
        return;
      }
      //check period
      if (
        this.period_datefrom == this.main_periodfrom &&
        this.period_dateto == this.main_periodto
      ) {
        this.status_update_dateperiod = 0;
      } else {
        const checkperiod = await api.getcheckeditperiodquota(
          this.main_id,
          this.period_datefrom,
          this.period_dateto,
          this.main_periodfrom,
          this.main_periodto
        );
        //console.log(checkperiod.data)
        this.status_update_dateperiod = 1;
        if (checkperiod.data[0].status > 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "ช่วงเวลาซ้ำ กรุณาตรวจสอบข้อมูล",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      for (let i = 0; i < this.desserts.length; i++) {
        if (this.desserts[i].disabled) {
        } else {
          if (this.desserts[i].quotaD == "") {
            this.desserts[i].quotaD = 0;
          }
          if (this.desserts[i].quotaH == "") {
            this.desserts[i].quotaH = 0;
          }
          if (this.desserts[i].quotaH < 0 || this.desserts[i].quotaH >= 8) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Please Check Data Quota(Hour) " +
                this.desserts[i].leave_type +
                " in ( 0 - 7 ) Hour",
              "text-h5 red--text text-center"
            );
            return;
          }
          if (this.desserts[i].quotaD < 0 || this.desserts[i].quotaH < 0) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Please Check Type Data Quota " + this.desserts[i].leave_type,
              "text-h5 red--text text-center"
            );
            return;
          }
          if (this.desserts[i].quotaD == 0 && this.desserts[i].quotaH == 0) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Please Enter Data Quota " + this.desserts[i].leave_type,
              "text-h5 red--text text-center"
            );
            return;
          }
          let quotaCheck = 0;
          quotaCheck =
            Number(this.desserts[i].quotaD) +
            Number(this.desserts[i].quotaH) / 8;
          if (quotaCheck < this.desserts[i].use_leave) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "(Quota < Used ) Please Select New Leave Quota  ",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
      }

      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });
      // เพิ่มข้อมูล
      this.desserts.forEach(async (item, index) => {
        if (item.quota_id) {
          this.statusAdd = item.status;
        }
        if (this.status_update_dateperiod == 1) {
          if (item.quota_id) {
            this.update_per.leave_period_from = this.period_datefrom;
            this.update_per.leave_period_to = this.period_dateto;
            api.updateQuota(item.quota_id, this.update_per);
          }
        } else {
          if (item.quota_id) {
            this.remarklist.remark = this.remark;
            // console.log(this.remark)
            api.updateQuota(item.quota_id, this.remarklist);
          }
        }
        if (item.disabled) {
        } else {
          let quotacre = 0;
          quotacre = Number(item.quotaD) + Number(item.quotaH) / 8;
          if (item.quota_id) {
            this.add_leaveQuota.quota = quotacre;
            this.add_leaveQuota.remark = this.remark;
            api.updateQuota(item.quota_id, this.add_leaveQuota);
          } else {
            this.add_leaveQuota.employee_id = this.main_id;
            this.add_leaveQuota.leave_period_from = this.period_datefrom;
            this.add_leaveQuota.leave_period_to = this.period_dateto;
            this.add_leaveQuota.leave_type_id = item.id;
            this.add_leaveQuota.quota = quotacre;
            this.add_leaveQuota.remark = this.remark;
            this.add_leaveQuota.status = this.statusAdd;
            this.add_leaveQuota.company_id = this.company_id;
            // console.log(this.add_leaveQuota)
            api.createLeaveQuota(this.add_leaveQuota);
          }
        }
      });
      loader.hide();
      this.$store.state.global_push_dialog = true;
      this.setupAlertDialogPush(
        true,
        "Information Saved",
        "Information successfully saved",
        "text-h5 green--text text-center",
        "/leave-quota"
      );
    },
    async changeRoute(item) {
      console.log(item.item.quotaH);
      if (item.item.quotaH < 0 || item.item.quotaH >= 8) {
        item.item.quotaH = item.item.quotaHC;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Check Data Quota(Hour) " +
            item.item.leave_type +
            " in ( 0 - 7 ) Hour",
          "text-h5 red--text text-center"
        );
        return;
      }
      //console.log(item.item)
      if (item.item.quotaD < 0 || item.item.quotaH < 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Check Data ",
          "text-h5 red--text text-center"
        );
        return;
      }
      let quota = 0;
      quota = Number(item.item.quotaD) + Number(item.item.quotaH) / 8;
      // console.log(quota)
      if (quota < item.item.use_leave) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "(Quota < Used ) Please Select New Leave Quota  ",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    enterSelect(values) {
      if (values.length > 0) {
        this.checklistNull = 1;
      } else {
        this.checklistNull = 0;
      }
      this.desserts.forEach((item) => {
        item.disabled = true;
      });
      values.forEach((item, index) => {
        item.disabled = false;
      });
    },
    closeDelete() {
      this.sumtotal = 0;
      this.sumGrandTotal = 0;

      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        this.sumtotal += parseInt(item.amount, 10);
      });
      this.sumGrandTotal = (this.sumtotal * (1 + this.vatCal / 100)).toFixed(2);
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },

    initialize() {},
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    // deleteItem(item) {
    //   console.log(item.id)
    // },
    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewMultiImage: function (event) {
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.preview_list.push(e.target.result);
          };
          if (input.files[index].type.split("/")[0] === "image") {
            this.image_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      //console.log(this.image_list);
    },
    reset: function () {
      this.image = null;
      this.preview = null;
      this.image_list = [];
      this.preview_list = [];
    },
    clickremoveimage(index) {
      this.indeximage = index;
      this.dialogDeleteimage = true;
    },
    async removeimage(index) {
      this.preview_list.splice(this.indeximage, 1);
      this.image_list.splice(this.indeximage, 1);

      this.dialogDeleteimage = false;
    },
    closeDeleteimage() {
      this.indeximage = null;
      this.dialogDeleteimage = false;
    },
  },
  async beforeCreate() {
    //console.log("beforeCreate");
    this.$store.state.navMenu = true;

    // this.showdefaultsignature();
  },
  async created() {
    // this.showdefaultsignature();
  },
};
</script>

<style scoped>
.text-left {
  color: aliceblue;
}
.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}
.v-autocomplete.v-input > .v-input__control > .v-input__slot {
  min-height: 10px;
}
.widthsizeformadvance {
  width: 60%;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}
.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}
.widthsize80formadvance {
  width: 80%;
}
.heightsize55formadvance {
  height: 55px;
}

.heightsize80performadvance {
  height: 60%;
}

.heightsize70formadvance {
  height: 70px;
}

.widthsize8055formadvance {
  width: 80px;
  height: 55px;
}

.advance-text-height {
  height: 70px;
}

.some-other-style {
  background: blue;
}
.my-header-style {
  color: #ffffff !important;
  background: #515151;
}

.data-table-button {
  color: #9e3b1b;
}

.my-header2-style {
  color: #ffffff !important;
  background: #515151;
  width: 120px;
}

.my-header3-style {
  color: #ffffff !important;
  background: #515151;
  width: 80px;
}

.my-header4-style {
  color: #ffffff !important;
  background: #515151;
  width: 150px;
}
.btnuploadfile {
  border: 2px solid;
}
</style>
